import type { CardTypes, HeadingTypes } from '@etg/wings';
import { Card, Heading, Inline, Stack } from '@etg/wings';
import type { ReactNode } from 'react';

interface TitledCardProps extends CardTypes {
  children: ReactNode;
  className?: string;
  headingAs?: `h${HeadingTypes['level']}`;
  headingLevel?: HeadingTypes['level'];
  id?: string;
  icon?: ReactNode;
  tabIndex?: number;
  title: string;
}

const TitledCard = ({
  children,
  className,
  headingAs,
  headingLevel = 2,
  icon,
  title,
  ...rest
}: TitledCardProps) => (
  <Card className={className} {...rest}>
    <Stack>
      <Inline alignY="center" noWrap spacing={8}>
        {icon}
        <Heading as={headingAs} level={headingLevel}>
          {title}
        </Heading>
      </Inline>
      <div>{children}</div>
    </Stack>
  </Card>
);

export default TitledCard;
